import {
  AccountBalanceWalletOutlined,
  CalculateOutlined,
  DomainOutlined,
} from '@mui/icons-material'

export function CreditIcon() {
  return <AccountBalanceWalletOutlined fontSize="inherit" />
}

export function AccountingIcon() {
  return <CalculateOutlined fontSize="inherit" />
}

export function CompanyIcon() {
  return <DomainOutlined fontSize="inherit" />
}
